(() => {
  class TableNoPaginationController {
    constructor($scope, $state, $location) {
      'ngInject';

      Object.assign(this, {
        $location,
        $scope,
        $state
      });
      this.clickCount = 0;
    }

    $onInit() {}

  }

  TableNoPaginationController.$inject = ["$scope", "$state", "$location"];
  angular.module('pims').component('kjnopTable', {
    transclude: true,
    templateUrl: 'app/components/table-no-pagination/table-nop.html',
    controller: TableNoPaginationController,
    bindings: {
      sortBy: '=',
      sortOrder: '=',
      onSort: '&',
      striped: '<',
      thirdClickBackDefault: '<',
      chargemodal: '<'
    }
  }).directive('kjnopTableHeader', () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: `
          <div class="thead">
            <div class="tr" ng-transclude></div>
          </div>
        `
    };
  }).directive('kjnopTableColumn', ["$timeout", $timeout => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      require: '^^kjnopTable',
      scope: {
        sortable: '=?'
      },
      template: `
          <div class="th" ng-click="sort()">
            <span ng-transclude></span>
            <i ng-if="sortable && showSort" class="ion-chevron-{{ sortDirection }}">
          </div>
        `,

      link(scope, element, attrs, tableCtrl) {
        if (scope.sortable) {
          setArrow();
        }

        function setArrow() {
          scope.showSort = tableCtrl.sortBy === scope.sortable;
          scope.sortDirection = tableCtrl.sortOrder === 'asc' ? 'up' : 'down';
        }

        scope.$watch(() => {
          return tableCtrl.sortBy;
        }, setArrow);

        scope.sort = () => {
          if (!scope.sortable) {
            return;
          }

          if (!this.clickCount) this.clickCount = 1;
          this.clickCount += 1; // clicking already actively sorted column, change direction

          if (tableCtrl.sortBy === scope.sortable) {
            if (tableCtrl.thirdClickBackDefault) {
              if (this.clickCount === 1) tableCtrl.sortOrder = 'desc';
              if (this.clickCount === 2) tableCtrl.sortOrder = 'asc';

              if (this.clickCount === 3) {
                tableCtrl.sortOrder = 'desc';
                tableCtrl.sortBy = 'date_written';
                this.clickCount = 1;
              }
            } else {
              tableCtrl.sortOrder = tableCtrl.sortOrder === 'asc' ? 'desc' : 'asc';
            }
          } else {
            if (tableCtrl.thirdClickBackDefault) {
              tableCtrl.sortOrder = 'desc';
              this.clickCount = 1;
            }

            tableCtrl.sortBy = scope.sortable;
          }

          $timeout(() => {
            setArrow();
            tableCtrl.onSort();
          });
        };
      }

    };
  }]).directive('kjnopTableBody', () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: '<div class="tbody" ng-transclude></div>'
    };
  }).directive('kjnopTableRow', () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      require: '^^kjnopTable',
      template: `<a ng-class="{'tr no-transition charge-completevisit-modal' : chargemodal, 'tr no-transition' : !chargemodal}" ng-transclude></a>`,

      link(scope, element, attrs, tableCtrl) {
        scope.chargemodal = tableCtrl.chargemodal;
      } // template: '<a class="tr no-transition" ng-transclude></a>',


    };
  }).directive('kjnopTableRowNoLink', () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: '<div class="tr no-transition" ng-transclude></div>'
    };
  }).directive('kjnopTableCell', () => {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      transclude: true,
      require: '^^kjnopTable',
      template: `<div ng-class="{'td charge-completevisit-modal' : chargemodal, 'td' : !chargemodal}" ng-transclude></div>`,

      link(scope, element, attrs, tableCtrl) {
        scope.chargemodal = tableCtrl.chargemodal;
      } // template: '<div class="td" ng-transclude></div>',


    };
  });
})();